import React from "react";
import "./MapLocations.css";
import { Link, useHistory, useParams } from "react-router-dom"
import API from "../../utils/API"
import { prepareStageEntry, getDefaultSpawn } from "../../config/worldTransitions";

function Cliffs() {
    const {id} = useParams()
    const history = useHistory()
    return(
        <div className="map-location text-center special cliffDiv">
            <img src={require("../../images/mapCliff.jpg")} alt="Cliff" className="cliff" />
            <Link className="stage-link map-location__control" to={"/cliffs/" + id} onClick={async (event) => {
                event.preventDefault()
                prepareStageEntry(id, "cliff", getDefaultSpawn("cliff"))
                try { await API.UpdateSpritePlace("cliff", id) } finally { history.push("/cliffs/" + id) }
            }}>Cliffs</Link>
        </div>
    )
}

export default Cliffs;